import React from "react";
import { useOverlayPopupOpen } from "../../hooks/use-overlay-popup-open";
import "../shared/popup-card.scss";

interface ClaimNumberDisplayProps {
  visible: boolean;
  claimNumber: string;
  onAcknowledge: () => void;
}

export const ClaimNumberDisplay: React.FC<ClaimNumberDisplayProps> = ({
  visible,
  claimNumber,
  onAcknowledge,
}) => {
  useOverlayPopupOpen(visible);
  if (!visible) return null;

  const numberToShow = claimNumber || "غير متوفر";

  return (
    <div className="popup-overlay">
      <div className="popup-card">
        <div className="popup-badge-row">
          <span className="popup-badge-icon">✅</span>
        </div>
        <h3 className="popup-title">تم فتح المطالبة</h3>
        <p className="popup-subtitle">رقم المطالبة الخاصة بك</p>
        <div className="popup-value-display">
          <div className="popup-value-display__text">{numberToShow}</div>
        </div>
        <button onClick={onAcknowledge} className="popup-btn-primary">
          تم
        </button>
      </div>
    </div>
  );
};
